import { Component, OnInit,Input } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router } from '@angular/router';
@Component({
  selector: 'app-bcappsearch',
  templateUrl: './bcappsearch.component.html',
  styleUrls: ['./bcappsearch.component.sass']
})
export class BcappsearchComponent implements OnInit {

  @Input('a') application: string;
  @Input('c') component: string;
  isLogin = false;
  constructor(private router: Router,private _global: GlobalService) { }

  ngOnInit(): void {
    if (this._global.isAuthenticated()) {
      this.isLogin = true;
    }
  }
  gotoCreate(){
    if(this.isLogin){
      this.router.navigate(['/create/'+this.application]);
    }else{
      this.router.navigate(['/login'], { queryParams: { returnUrl: '/create/'+this.application, 'navigateByUrl': false } });
    }
  }

}
